import { render, staticRenderFns } from "./main-content.vue?vue&type=template&id=52e6409c&scoped=true&"
import script from "./main-content.vue?vue&type=script&lang=js&"
export * from "./main-content.vue?vue&type=script&lang=js&"
import style0 from "./main-content.vue?vue&type=style&index=0&id=52e6409c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6409c",
  null
  
)

export default component.exports